<template>
  <div class="open-bank-form p-6">
    <el-card shadow="hover">
      <div class="header">
        <span>用户开通银行</span>
        <div class="actions">
          <el-button @click="$router.back()">返回</el-button>
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </div>
      </div>

      <div class="agreeContainer" v-if="form.bankType === 'HT-MC'">
        <el-checkbox v-model="htAgreeFlag" @change="handleSelectedAgree"></el-checkbox>
        <a style="flex: 1; color: deepskyblue; font-size: 15px; margin-left: 5px" @click="handleClickAgree">华通银行“e账户”注册会员号管理协议</a>
      </div>

      <el-form ref="formRef" :model="form" :rules="rules" label-width="110px" label-position="left">
        <!-- 顶层基础信息 -->
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="会员ID" prop="uid">
              <el-input v-model="form.uid" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="主体类型" prop="organizationType">
              <el-radio-group v-model="form.organizationType" disabled>
                <el-radio v-for="(sf, index) in organizationTypeOptions" :key="index" :label="sf.value">{{ sf.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="企业名称" prop="enterpriseName">
              <el-input v-model="form.enterpriseName" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行类型" prop="bankType">
              <el-radio-group v-model="form.bankType">
                <el-radio v-for="(sf, index) in bankTypeOptions" :key="index" :label="sf.value">{{ sf.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 股东/受益人：当法人同股东/受益人（任一为1）时，可以不填，否则必填 -->
        <div v-if="form.bankType == 'WSFAS-MC'">
          <el-divider content-position="left">受益人</el-divider>
          <div v-for="(item,idx) in form.beneficiaryItems" :key="idx" class="dynamic-item">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item>
                  {{item.beneficiaryName}}
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :prop="`beneficiaryItems.${idx}.beneficiaryGender`" :rules="shareholderSexReqSelRules(item)">
                  <el-select v-model.trim="item.beneficiaryGender" placeholder="性别">
                    <el-option v-for="opt in genders" :key="opt.value" :label="opt.label" :value="opt.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  证件号：{{item.beneficiaryIdNo}}
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  证件生效日期：{{item.beneficiaryIdEffDate}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item>
                  证件失效日期：{{item.beneficiaryIdOffDate}}
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  受益人电话：{{item.beneficiaryPhone}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  受益人地址：{{item.beneficiaryAddress}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="身份证正面" :prop="`beneficiaryItems.${idx}.beneficiaryIdFrontPicId`" :rules="rules.reqSel">
                  <el-upload
                      :show-file-list="false"
                      :on-success="(res, file) => uploadSfzSuccess(res, file, idx, 'beneficiaryIdFrontPicId')"
                      :on-error="(err, file) => uploadSfzError(err, file, idx,'beneficiaryIdFrontPicId')"
                      list-type="picture-card"
                      accept="image/jpeg,image/png"
                      name="multipartFile"
                      :data="{uid: form.uid, bankType: form.bankType, fileType: 'ID_PIC_A'}"
                      :action="uploadurl"
                      :ref="`upload-zcFileID`">
                    <div class="avatar-wrapper" @click="handleClickSfzUpload(idx,'beneficiaryIdFrontPicId')">
                      <img v-if="item.beneficiaryIdFrontPicIdPath" :src="prefixUrl + item.beneficiaryIdFrontPicIdPath" class="avatar">
                      <div v-if="item.beneficiaryIdFrontPicIdPath" class="mask">
                        <span class="el-icon-refresh">点击替换</span>
                      </div>
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </div>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过20M</div>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="身份证反面" :prop="`beneficiaryItems.${idx}.beneficiaryIdBackPicId`" :rules="rules.reqSel">
                  <el-upload
                      :show-file-list="false"
                      :on-success="(res, file) => uploadSfzSuccess(res, file, idx, 'beneficiaryIdBackPicId')"
                      :on-error="(err, file) => uploadSfzError(err, file, idx,'beneficiaryIdBackPicId')"
                      list-type="picture-card"
                      accept="image/jpeg,image/png"
                      name="multipartFile"
                      :data="{uid: form.uid, bankType: form.bankType, fileType: 'ID_PIC_B'}"
                      :action="uploadurl"
                      :ref="`upload-zcFileID`">
                    <div class="avatar-wrapper" @click="handleClickSfzUpload(idx,'beneficiaryIdBackPicId')">
                      <img v-if="item.beneficiaryIdBackPicIdPath" :src="prefixUrl + item.beneficiaryIdBackPicIdPath" class="avatar">
                      <div v-if="item.beneficiaryIdBackPicIdPath" class="mask">
                        <span class="el-icon-refresh">点击替换</span>
                      </div>
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </div>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过20M</div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div v-else-if="form.organizationType == '1' && form.bankType === 'HT-MC'">
          <el-divider content-position="left">受益人</el-divider>
          <div v-for="(item,idx) in form.beneficiaryItems" :key="idx" class="dynamic-item">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item>
                  {{item.beneficiaryName}}
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :prop="`beneficiaryItems.${idx}.beneficiaryGender`" :rules="shareholderSexReqSelRules(item)">
                  <el-select v-model.trim="item.beneficiaryGender" placeholder="性别">
                    <el-option v-for="opt in genders" :key="opt.value" :label="opt.label" :value="opt.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  证件号：{{item.beneficiaryIdNo}}
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  证件生效日期：{{item.beneficiaryIdEffDate}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item>
                  证件失效日期：{{item.beneficiaryIdOffDate}}
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  受益人电话：{{item.beneficiaryPhone}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  受益人地址：{{item.beneficiaryAddress}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item :prop="`beneficiaryItems.${idx}.items[0].beneficiaryType`" :rules="shareholderTyReqSelRules(true)">
                  <el-select v-model.trim="item.items[0].beneficiaryType" @change="handleTypeChange(item)" placeholder="受益所有权关系类型">
                    <el-option v-for="opt in types" :key="opt.value" :label="opt.label" :value="opt.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="item.items[0].beneficiaryType == '100'">
                <el-form-item :prop="`beneficiaryItems.${idx}.items[0].equityRate`" :rules="shareholderRateReqSelRules(item.items[0].beneficiaryType == '100')"><el-input v-model.trim="item.items[0].equityRate" placeholder="股权/合伙权益比例"/></el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :prop="`beneficiaryItems.${idx}.items[0].equityStartDate`" :rules="shareholderTyReqSelRules(true)">
                  <el-date-picker v-model.trim="item.items[0].equityStartDate" type="date" value-format="yyyy-MM-dd"
                                  placeholder="受益所有权形成日期"/>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :prop="`beneficiaryItems.${idx}.items[0].equityExpiryDate`" :rules="shareholderTyReqSelRules(true)">
                  <el-date-picker v-model.trim="item.items[0].equityExpiryDate" type="date" value-format="yyyy-MM-dd"
                                  placeholder="受益所有权终止日期"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10" v-if="item.items[0].beneficiaryType == '200'">
              <el-col :span="6">
                <el-form-item :prop="`beneficiaryItems.${idx}.items[0].benefitsRate`" :rules="shareholderRateReqSelRules(item.items[0].beneficiaryType == '200')">
                  <el-input v-model.trim="item.items[0].benefitsRate" placeholder="收益权比例"/>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :prop="`beneficiaryItems.${idx}.items[0].benefitsStartDate`" :rules="shareholderTyReqSelRules(item.items[0].beneficiaryType == '200')">
                  <el-date-picker v-model.trim="item.items[0].benefitsStartDate" type="date" value-format="yyyy-MM-dd"
                                  placeholder="收益所有权形成日期"/>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :prop="`beneficiaryItems.${idx}.items[0].benefitsExpiryDate`" :rules="shareholderTyReqSelRules(item.items[0].beneficiaryType == '200')">
                  <el-date-picker v-model.trim="item.items[0].benefitsExpiryDate" type="date" value-format="yyyy-MM-dd"
                                  placeholder="收益所有权终止日期"/>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :prop="`beneficiaryItems.${idx}.items[0].votingRate`" :rules="shareholderRateReqSelRules(item.items[0].beneficiaryType == '200')">
                  <el-input v-model.trim="item.items[0].votingRate" placeholder="表决权比例"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6" v-if="item.items[0].beneficiaryType == '200'">
                <el-form-item :prop="`beneficiaryItems.${idx}.items[0].votingStartDate`" :rules="shareholderTyReqSelRules(item.items[0].beneficiaryType == '200')">
                  <el-date-picker v-model.trim="item.items[0].votingStartDate" type="date" value-format="yyyy-MM-dd"
                                  placeholder="表决所有权形成日期"/>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="item.items[0].beneficiaryType == '200'">
                <el-form-item :prop="`beneficiaryItems.${idx}.items[0].votingExpiryDate`" :rules="shareholderTyReqSelRules(item.items[0].beneficiaryType == '200')">
                  <el-date-picker v-model.trim="item.items[0].votingExpiryDate" type="date" value-format="yyyy-MM-dd"
                                  placeholder="表决所有权终止日期"/>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="item.items[0].beneficiaryType == '300'">
                <el-form-item :prop="`beneficiaryItems.${idx}.items[0].actualControlType`" :rules="shareholderTyReqSelRules(item.items[0].beneficiaryType == '300')">
                  <el-select v-model.trim="item.items[0].actualControlType" @change="handleControlTypeChange(item)" placeholder="实际控制方式">
                    <el-option v-for="opt in controlTypes" :key="opt.value" :label="opt.label" :value="opt.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="item.actualControlType == '320'">
                <el-form-item :prop="`beneficiaryItems.${idx}.items[0].otherRemark`" :rules="shareholderRemarkReqRules(item.actualControlType == '320')">
                  <el-input type="textarea"
                            :rows="2"
                            v-model.trim="item.items[0].otherRemark" placeholder="其他形式备注信息"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6" v-if="item.items[0].beneficiaryType == '400'">
                <el-form-item :prop="`beneficiaryItems.${idx}.items[0].mangerPosition`" :rules="shareholderTyReqSelRules(item.items[0].beneficiaryType == '400')">
                  <el-select v-model.trim="item.items[0].mangerPosition" @change="handlePositionChange(item)" placeholder="高级管理人员职位">
                    <el-option v-for="opt in positions" :key="opt.value" :label="opt.label" :value="opt.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="item.items[0].mangerPosition == '160'">
                <el-form-item :prop="`beneficiaryItems.${idx}.items[0].otherPosition`" :rules="shareholderRemarkReqRules(item.mangerPosition == '160')">
                  <el-input type="textarea"
                            :rows="2"
                            v-model.trim="item.items[0].otherPosition" placeholder="其他职位备注"/>
                </el-form-item>
              </el-col>

              <el-col :span="6" v-if="item.items[0].beneficiaryType == '500'">
                <el-form-item :prop="`beneficiaryItems.${idx}.items[0].chnMangerPosition`" :rules="shareholderTyReqSelRules(item.items[0].beneficiaryType == '500')">
                  <el-select v-model.trim="item.items[0].chnMangerPosition" @change="handleChnPositionChange(item)" placeholder="在华最高层级高管职位">
                    <el-option v-for="opt in chnPositions" :key="opt.value" :label="opt.label" :value="opt.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="item.items[0].chnMangerPosition == '520'">
                <el-form-item :prop="`beneficiaryItems.${idx}.items[0].chnOtherPosition`" :rules="shareholderRemarkReqRules(item.mangerPosition == '520')">
                  <el-input type="textarea"
                            :rows="2"
                            v-model.trim="item.items[0].chnOtherPosition" placeholder="在华最高层级高管其他职位"/>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 苏商银行表单（SSQY-MC） -->
        <div v-show="form.bankType === 'SSQY-MC'">
          <el-divider content-position="left">苏商银行信息</el-divider>
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="本行卡" prop="ssBankInfo.bindType">
                <el-radio-group v-model="form.ssBankInfo.bindType">
                  <el-radio v-for="(sf, index) in systemOptions" :key="index" :label="sf.value">{{ sf.label }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="店群" prop="ssBankInfo.isStoreGroup">
                <el-radio-group v-model="form.ssBankInfo.isStoreGroup">
                  <el-radio v-for="(sf, index) in systemOptions" :key="index" :label="sf.value">{{ sf.label }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="主店工商名称" prop="ssBankInfo.storeBusinessName" v-if="form.ssBankInfo.isStoreGroup === '1'" :required="form.ssBankInfo.isStoreGroup === '1'">
                <el-input v-model="form.ssBankInfo.storeBusinessName" placeholder="店群客户必填"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="主店统一信用代码" prop="ssBankInfo.storeBusinessLicense" v-if="form.ssBankInfo.isStoreGroup === '1'" :required="form.ssBankInfo.isStoreGroup === '1'">
                <el-input v-model="form.ssBankInfo.storeBusinessLicense" placeholder="店群客户必填"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="实际经营地址" prop="ssBankInfo.actualBusinessAddress">
            <el-input v-model="form.ssBankInfo.actualBusinessAddress" type="textarea" :rows="3" maxlength="100" show-word-limit
                      placeholder="企业实际经营地址"></el-input>
          </el-form-item>

          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="是否线上场景" prop="ssBankInfo.isOnlineScene">
                <el-radio-group v-model="form.ssBankInfo.isOnlineScene">
                  <el-radio v-for="(sf, index) in systemOptions" :key="index" :label="sf.value">{{ sf.label }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业网址" prop="ssBankInfo.onlineEnterpriseWebsite">
                <el-input v-model="form.ssBankInfo.onlineEnterpriseWebsite" placeholder="必填：企业网站"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="网店名称" prop="ssBankInfo.onlineShopName">
                <el-input v-model="form.ssBankInfo.onlineShopName" placeholder="必填：网店名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="是否加盟连锁" prop="ssBankInfo.isFranchiseChain">
            <el-radio-group v-model="form.ssBankInfo.isFranchiseChain">
              <el-radio v-for="(sf, index) in systemOptions" :key="index" :label="sf.value">{{ sf.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>

        <!-- 华通银行表单（HT-MC） -->
        <div v-show="form.bankType === 'HT-MC'">
          <el-divider content-position="left">华通银行信息</el-divider>
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="商户注册省" prop="htBankInfo.registerProvince">
                <el-select v-model="form.htBankInfo.registerProvince" placeholder="请选择省" filterable clearable>
                  <el-option v-for="p in provinces" :key="p.code" :label="p.name" :value="p.code"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商户注册市" prop="htBankInfo.registerCity">
                <el-select v-model="form.htBankInfo.registerCity" placeholder="请选择市" :disabled="!form.htBankInfo.registerProvince"
                    filterable clearable>
                  <el-option v-for="c in filteredCities" :key="c.code" :label="c.name" :value="c.code"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商户注册区" prop="htBankInfo.registerDistinct">
                <el-select v-model="form.htBankInfo.registerDistinct" placeholder="请选择区/县" :disabled="!form.htBankInfo.registerCity"
                    filterable clearable>
                  <el-option v-for="d in filteredDistricts" :key="d.code" :label="d.name" :value="d.code"/>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="行业" prop="htBankInfo.occupation">
                <el-select v-model="form.htBankInfo.occupation" filterable placeholder="必选">
                  <el-option v-for="opt in occupationOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="国籍地区编码" prop="htBankInfo.country">
                <el-select v-model="form.htBankInfo.country">
                  <el-option v-for="opt in countyOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业类型" prop="htBankInfo.enterpriseType">
                <el-select v-model="form.htBankInfo.enterpriseType" filterable>
                  <el-option v-for="opt in enterpriseTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="企业规模" prop="htBankInfo.enterpriseScale">
                <el-select v-model="form.htBankInfo.enterpriseScale">
                  <el-option v-for="opt in enterpriseScaleOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="上市类型" prop="htBankInfo.listingType">
                <el-select v-model="form.htBankInfo.listingType" clearable>
                  <el-option v-for="opt in listingTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业经济性质" prop="htBankInfo.economicNature">
                <el-select v-model="form.htBankInfo.economicNature" filterable>
                  <el-option v-for="opt in economicNatureOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="机构证件类型" prop="htBankInfo.businessType">
                <el-select v-model="form.htBankInfo.businessType" filterable clearable>
                  <el-option v-for="opt in businessTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="账户区域" prop="htBankInfo.accArea">
                <el-radio-group v-model="form.htBankInfo.accArea">
                  <el-radio label="0">境内</el-radio>
                  <el-radio label="1">境外</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16" v-if="form.organizationType === '1'">
            <el-col :span="12">
              <el-form-item label="章程/合伙协议" prop="htBankInfo.zcFileID">
                <el-upload
                    :show-file-list="false"
                    :on-success="(res, file) => uploadSuccess(res, file, 'zcFileID')"
                    :on-error="(err, file) => uploadError(err, file, 'zcFileID')"
                    list-type="picture-card"
                    accept="image/jpeg,image/png"
                    name="multipartFile"
                    :data="{uid: form.uid, bankType: form.bankType, fileType: 'BENEFICIARY_IDENTIFICATION_MATERIAL'}"
                    :action="uploadurl"
                    :ref="`upload-zcFileID`">
                  <div class="avatar-wrapper" @click="handleClickUpload('zcFileID')">
                    <img v-if="form.htBankInfo.zcFileIDPath" :src="prefixUrl + form.htBankInfo.zcFileIDPath" class="avatar">
                    <div v-if="form.htBankInfo.zcFileIDPath" class="mask">
                      <span class="el-icon-refresh">点击替换</span>
                    </div>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </div>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过20M</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="高管相关资料" prop="htBankInfo.zlFileID">
                <el-upload
                    :show-file-list="false"
                    :on-success="(res, file) => uploadSuccess(res, file, 'zlFileID')"
                    :on-error="(err, file) => uploadError(err, file, 'zlFileID')"
                    list-type="picture-card"
                    accept="image/jpeg,image/png"
                    name="multipartFile"
                    :data="{uid: form.uid, bankType: form.bankType, fileType: 'BENEFICIARY_IDENTIFICATION_MATERIAL'}"
                    :action="uploadurl"
                    :ref="`upload-zlFileID`">
                  <div class="avatar-wrapper" @click="handleClickUpload('zlFileID')">
                    <img v-if="form.htBankInfo.zlFileIDPath" :src="prefixUrl + form.htBankInfo.zlFileIDPath" class="avatar">
                    <div v-if="form.htBankInfo.zlFileIDPath" class="mask">
                      <span class="el-icon-refresh">点击替换</span>
                    </div>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </div>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 微众银行表单（WSFAS-MC） -->
        <div v-show="form.bankType === 'WSFAS-MC'">
          <el-divider content-position="left">微众银行信息</el-divider>
          <el-row>
            <el-col :span="8">
              <el-form-item label="商户业务类型" prop="wzBankInfo.merchantBizType">
                <el-radio-group v-model="form.wzBankInfo.merchantBizType">
                  <el-radio v-for="p in bizOptions" :label="p.value" :key="p.value">{{p.label}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-divider content-position="left">客户文件</el-divider>
          <el-row :gutter="10">
            <el-col :span="12" v-for="(item,idx) in form.wzBankInfo.fileList" :key="'file'+idx" class="dynamic-item">
              <el-form-item :label="item.fileName" label-width="160px" :prop="`wzBankInfo.fileList.${idx}.fileIdentifier`">
                <el-upload
                    :show-file-list="false"
                    :on-success="(res, file) => uploadWzSuccess(res, file, idx)"
                    :on-error="(err, file) => uploadWzError(err, file, idx)"
                    list-type="picture-card"
                    accept="image/jpeg,image/png"
                    name="multipartFile"
                    :data="{fileType: 'OTHER_MATERIAL', bankType: form.bankType, uid: form.uid}"
                    :action="uploadurl"
                    :ref="`upload-${idx}`">
                  <div class="avatar-wrapper" @click="handleClickWzUpload(idx)">
                    <img v-if="item.filePath" :src="prefixUrl + item.filePath" class="avatar">
                    <div v-if="item.filePath" class="mask">
                      <span class="el-icon-refresh">点击替换</span>
                    </div>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </div>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-card>

    <!-- 预览弹窗 -->
    <el-dialog title="华通银行“e账户”注册会员号管理协议" @close="handleCloseLookAgree" :visible.sync="lookAgreeVisiable" fullscreen>
      <!-- 这里渲染转换后的 HTML -->
      <div v-html="htmlContent" class="word-content"></div>
    </el-dialog>
  </div>
</template>

<script>
import mammoth from 'mammoth';
import axios from 'axios'
import {SAMPLE_DISTRICTS, SAMPLE_CITIES, SAMPLE_PROVINCES} from "@/assets/js/china_city_arrays"
export default {
  name: 'OpenBankForm',
  data() {
    return {
      prefixUrl: this.GLOBAL.imgURL,
      uploadurl: this.GLOBAL.imgURL+'open-account/uploadBankPic',
      lookAgreeVisiable: false,
      htmlContent: null,
      htAgreeFlag: false,
      // 表单模型（与后端 DTO 对应）
      form: {
        accountId: this.$route.query.id,
        uid: this.$route.query.uid,
        organizationType: this.$route.query.lx === 'INDIVIDUAL' ? '2' : '1',
        enterpriseName: this.$route.query.name, // 必填
        bankType: 'HT-MC', // 必填
        beneficiaryItems: [],
        ssBankInfo: {
          bindType: '0',
          incomeOwnerProvePicId: '',
          isStoreGroup: '0',
          storeBusinessName: '',
          storeBusinessLicense: '',
          channelBusinessName: '',
          customerIp: '',
          institutionalIp: '',
          networkAccessTime: '',
          actualBusinessAddress: '',
          isOnlineScene: '1', // Y
          onlineEnterpriseWebsite: '', // Y
          onlineShopName: '', // Y
          isFranchiseChain: '0', // Y
          contact: {
            name: '', // Y
            idType: '', // Y
            idNo: '', // Y
            idStartDate: '', // 支持"长期"
            idEndDate: '', // 支持"长期"
            phone: '',
            contactPicA: '',
            contactPicB: '',
          },
        },
        htBankInfo: {
          registerProvince: '', // Y
          registerCity: '', // Y
          registerDistinct: '', // Y
          occupation: 'R', // Y
          country: 'CHN', // Y 三位字母
          enterpriseType: '311', // Y
          enterpriseScale: '41', // Y
          listingType: '99',
          economicNature: '175', // Y
          businessType: '',
          accArea: '0',
          entryTime: null,
          readingDuration: null,
          checkboxClickTime: null,
          zcFileIDPath: null,
          zcFileID: null,
          zlFileID: null,
          zlFileIDPath: null,
        },
        wzBankInfo: {
          merchantBizType: '',
          fileList:[
            {
              fileName: '平台后台经营主体',
              fileType: '',
              bizScene: 'FZT_M_1',
              fileIdentifier: '',
              filePath: ''
            },
            {
              fileName: '平台后台店铺信息',
              fileType: '',
              bizScene: 'FZT_M_1',
              fileIdentifier: '',
              filePath: ''
            },
            {
              fileName: '平台后台交易数据',
              fileType: '',
              bizScene: 'FZT_M_1',
              fileIdentifier: '',
              filePath: ''
            },
            {
              fileName: '平台后台订单明细',
              fileType: '',
              bizScene: 'FZT_M_1',
              fileIdentifier: '',
              filePath: ''
            },
            {
              fileName: '平台后台资金流水',
              fileType: '',
              bizScene: 'FZT_M_1',
              fileIdentifier: '',
              filePath: ''
            },
            {
              fileName: '移动端商家资质',
              fileType: '',
              bizScene: 'FZT_M_1',
              fileIdentifier: '',
              filePath: ''
            },
            {
              fileName: '移动端店铺详情',
              fileType: '',
              bizScene: 'FZT_M_1',
              fileIdentifier: '',
              filePath: ''
            },
            {
              fileName: '移动端店铺橱窗',
              fileType: '',
              bizScene: 'FZT_M_1',
              fileIdentifier: '',
              filePath: ''
            },
          ]
        }
      },
      lookAgree: false,
      chnPositions:[
        {
          value: '510',
          label: '分支机构负责人'
        },
        {
          value: '520',
          label: '其他高级管理人员'
        },
      ],
      positions: [
        {
          value: '300',
          label: '法定代表人'
        },
        {
          value: '111',
          label: '董事长'
        },
        {
          value: '112',
          label: '总经理'
        },
        {
          value: '121',
          label: '董事'
        },
        {
          value: '128',
          label: '合伙人'
        },
        {
          value: '160',
          label: '其他'
        }
      ],
      controlTypes: [
        {
          value: '310',
          label: '协议约定形式'
        },
        {
          value: '320',
          label: '其他形式'
        }
      ],
      genders: [
        {
          value: '1',
          label: '男'
        },
        {
          value: '2',
          label: '女'
        }
      ],
      types: [
        {
          value: '100',
          label: '股权/合作权益'
        },
        {
          value: '200',
          label: '收益权/表决权'
        },
        {
          value: '300',
          label: '实际控制'
        },
        {
          value: '400',
          label: '负责日常经营管理的高级管理人员'
        },
        {
          value: '500',
          label: '在华最高层级高级管理人员'
        }
      ],
      PROVINCES: SAMPLE_PROVINCES, // level = 1
      CITIES: SAMPLE_CITIES,       // level = 2
      DISTRICTS: SAMPLE_DISTRICTS, // level = 3

      // 选项
      systemOptions: [
        { label: '否', value: '0' },
        { label: '是', value: '1' },
      ],
      organizationTypeOptions: [
        { label: '企业', value: '1' },
        { label: '个体工商户', value: '2' },
      ],
      bankTypeOptions: [
        { label: '微众银行', value: 'WSFAS-MC' },
        { label: '华通银行', value: 'HT-MC' },
        // { label: '苏商企业号', value: 'SSQY-MC' },
      ],
      occupationOptions: [
        { value: 'A', label: '农、林、牧、渔业' },
        { value: 'B', label: '采矿业' },
        { value: 'C', label: '制造业' },
        { value: 'D', label: '电力/热力/燃气/水生产供应' },
        { value: 'E', label: '建筑业' },
        { value: 'F', label: '批发和零售业' },
        { value: 'G', label: '交通运输/仓储/邮政' },
        { value: 'H', label: '住宿和餐饮业' },
        { value: 'I', label: '信息传输/软件/信息技术服务业' },
        { value: 'J', label: '金融业' },
        { value: 'K', label: '房地产业' },
        { value: 'L', label: '租赁和商务服务业' },
        { value: 'M', label: '科学研究和技术服务业' },
        { value: 'N', label: '水利/环境/公共设施管理' },
        { value: 'O', label: '居民服务/修理/其他服务业' },
        { value: 'P', label: '教育' },
        { value: 'Q', label: '卫生和社会工作' },
        { value: 'R', label: '文化/体育/娱乐业' },
        { value: 'S', label: '公共管理/社会保障/社会组织' },
        { value: 'T', label: '国际组织' },
        { value: 'X', label: '未知' },
      ],
      enterpriseTypeOptions: [
        { value: '111', label: '有限责任公司' },
        { value: '112', label: '股份有限公司' },
        { value: '119', label: '其他法人' },
        { value: '121', label: '事业单位法人' },
        { value: '122', label: '社会团体法人' },
        { value: '123', label: '捐助法人（基金会）' },
        { value: '124', label: '捐助法人（社会服务机构）' },
        { value: '125', label: '捐助法人（宗教活动场所）' },
        { value: '129', label: '其他非营利法人' },
        { value: '131', label: '机关法人' },
        { value: '132', label: '农村集体经济组织法人' },
        { value: '133', label: '城镇/农村合作经济组织法人' },
        { value: '134', label: '基层群众性自治组织法人' },
        { value: '139', label: '其他特别法人' },
        { value: '211', label: '个人独资企业' },
        { value: '212', label: '合伙企业' },
        { value: '213', label: '不具法人资格的营利性专业服务机构' },
        { value: '219', label: '其他营利性非法人机构' },
        { value: '221', label: '不具法人资格的非营利性专业服务机构' },
        { value: '229', label: '其他非营利性非法人组织' },
        { value: '311', label: '个体工商户' },
      ],
      enterpriseScaleOptions: [
        { value: '20', label: '大型' },
        { value: '30', label: '中型' },
        { value: '40', label: '小型' },
        { value: '41', label: '微型' },
        { value: '99', label: '其他' },
      ],
      listingTypeOptions: [
        { value: '01', label: 'A股' },
        { value: '02', label: 'B股' },
        { value: '03', label: 'H股' },
        { value: '99', label: '其他' },
      ],
      economicNatureOptions: [
        { value: '100', label: '内资' },
        { value: '110', label: '国有全资' },
        { value: '120', label: '集体全资' },
        { value: '130', label: '股份合作' },
        { value: '140', label: '联营' },
        { value: '141', label: '国有联营' },
        { value: '142', label: '集体联营' },
        { value: '143', label: '国有与集体联营' },
        { value: '149', label: '其他联营' },
        { value: '150', label: '有限责任公司' },
        { value: '151', label: '国有独资公司' },
        { value: '159', label: '其他有限责任公司' },
        { value: '160', label: '股份有限公司' },
        { value: '170', label: '私有' },
        { value: '171', label: '私有独资' },
        { value: '172', label: '私有合伙' },
        { value: '173', label: '私营有限责任公司' },
        { value: '174', label: '私营股份有限公司' },
        { value: '175', label: '个体经营' },
        { value: '179', label: '其他私有' },
        { value: '190', label: '其他内资' },
        { value: '200', label: '港澳台投资' },
        { value: '210', label: '内地和港澳台合资' },
        { value: '220', label: '内地和港澳台合作' },
        { value: '230', label: '港澳台独资' },
        { value: '240', label: '港澳台投资股份有限公司' },
        { value: '290', label: '其他港澳台投资' },
        { value: '300', label: '国外投资' },
        { value: '310', label: '中外合资' },
        { value: '320', label: '中外合作' },
        { value: '330', label: '外资' },
        { value: '340', label: '国外投资股份有限公司' },
        { value: '390', label: '其他国外投资' },
        { value: '400', label: '境外机构' },
        { value: '900', label: '其他' },
      ],
      businessTypeOptions: [
        { value: '203', label: '民办非企业登记证书' },
        { value: '235', label: '国有全资' },
        { value: '216', label: '集体全资' },
        { value: '226', label: '股份合作' },
        { value: '232', label: '联营' },
        { value: '233', label: '国有联营' },
        { value: '299', label: '集体联营' },
        { value: '218', label: '国有与集体联营' },
      ],
      countyOptions: [
        { value: 'CHN', label: '中国' },
        { value: 'HKG', label: '中国香港' },
        { value: 'MAC', label: '中国澳门' },
        { value: 'TWN', label: '中国台湾' }
      ],
      bizOptions: [
        { value: '1', label: '全渠道收款' },
        { value: '2', label: '商户资金结算' }
      ],
    };
  },
  computed: {
    provinces() {
      // 直接全部省
      return this.PROVINCES;
    },
    filteredCities() {
      const provinceCode = this.form.htBankInfo && this.form.htBankInfo.registerProvince;
      if (!provinceCode) return [];
      // 规则：市编码前2位和省编码前2位一致即可
      const prefix2 = provinceCode.slice(0, 2);
      return this.CITIES.filter((c) => c.level === 2 && c.code.startsWith(prefix2));
    },
    filteredDistricts() {
      const cityCode = this.form.htBankInfo && this.form.htBankInfo.registerCity;
      if (!cityCode) return [];
      // 规则：区县编码前4位和市编码前4位一致即可
      const prefix4 = cityCode.slice(0, 4);
      return this.DISTRICTS.filter((d) => d.level === 3 && d.code.startsWith(prefix4));
    },
    legalShareOrBeneficiary(){
      const c = this.form.createBaseInfo
      return c.legalIsBeneficiary === '1' || c.legalIsShareholder === '1'
    },
    // 校验规则
    rules() {
      const isHT = this.form.bankType === 'HT-MC';
      const isWZ = this.form.bankType === 'WSFAS-MC';
      const isSS = this.form.bankType === 'SSQY-MC';

      const reqSel = [{required: true, message: '必传', trigger: 'change'}]
      let gz = {
        bankType: [{ required: true, message: '请选择银行类型', trigger: 'change' }],
        // 苏商（必填）
        // 'ssBankInfo.isOnlineScene': [{ required: isSS, message: '请选择是否线上场景', trigger: 'change' }],
        // 'ssBankInfo.onlineEnterpriseWebsite': [
        //   { required: isSS, message: '请输入企业网址', trigger: 'blur' },
        //   { validator: (_r, v, cb) => this.validateURL(v, cb), trigger: 'blur' },
        // ],
        // 'ssBankInfo.onlineShopName': [{ required: isSS, message: '请输入网店名称', trigger: 'blur' }],
        // 'ssBankInfo.isFranchiseChain': [{ required: isSS, message: '请选择是否加盟连锁', trigger: 'change' }],

        // 华通（必填）
        'htBankInfo.registerProvince': [{ required: isHT, message: '请选择注册省', trigger: 'change' }],
        'htBankInfo.registerCity': [{ required: isHT, message: '请选择注册市', trigger: 'change' }],
        'htBankInfo.registerDistinct': [{ required: isHT, message: '请选择注册区', trigger: 'change' }],
        'htBankInfo.occupation': [{ required: isHT, message: '请选择行业', trigger: 'change' }],
        'htBankInfo.country': [{ required: isHT, message: '请选择国家', trigger: 'change' }],
        'htBankInfo.enterpriseType': [{ required: isHT, message: '请选择企业类型', trigger: 'change' }],
        'htBankInfo.enterpriseScale': [{ required: isHT, message: '请选择企业规模', trigger: 'change' }],
        'htBankInfo.listingType': [{ required: isHT, message: '请选择上市类型', trigger: 'change' }],
        'htBankInfo.economicNature': [{ required: isHT, message: '请选择企业经济性质', trigger: 'change' }],
        'htBankInfo.zcFileID': [{ required: this.form.organizationType=='1' && isHT, message: '请上传章程/合伙协议', trigger: 'change' }],
        'htBankInfo.zlFileID': [{ required: this.form.organizationType=='1' && isHT, message: '请上传高管相关资料', trigger: 'change' }],

        // 微众（必填）
        'wzBankInfo.merchantBizType': [{ required: isWZ, message: '请选择商户业务类型', trigger: 'change' }],
        'wzBankInfo.fileList.0.fileIdentifier': [{ required: isWZ, message: '请上传移动端商家资质截屏', trigger: 'change' }],
        'wzBankInfo.fileList.1.fileIdentifier': [{ required: isWZ, message: '请上传平台后台经营主体截屏', trigger: 'change' }],
        'wzBankInfo.fileList.2.fileIdentifier': [{ required: isWZ, message: '请上传平台后台店铺信息截屏', trigger: 'change' }],
        'wzBankInfo.fileList.3.fileIdentifier': [{ required: isWZ, message: '请上传平台后台交易数据截屏', trigger: 'change' }],
        'wzBankInfo.fileList.4.fileIdentifier': [{ required: isWZ, message: '请上传平台后台订单明细截屏', trigger: 'change' }],
        'wzBankInfo.fileList.5.fileIdentifier': [{ required: isWZ, message: '请上传平台后台资金流水截屏', trigger: 'change' }],
        'wzBankInfo.fileList.6.fileIdentifier': [{ required: isWZ, message: '请上传移动端店铺详情截图', trigger: 'change' }],
        'wzBankInfo.fileList.7.fileIdentifier': [{ required: isWZ, message: '请上传移动端店铺橱窗截屏', trigger: 'change' }],
        reqSel
      }
      console.log("rules:")
      console.log(gz)

      return gz
    },
  },
  watch: {
    'form.htBankInfo.registerProvince'() {
      // 省变更时，清空市、区
      this.form.htBankInfo.registerCity = '';
      this.form.htBankInfo.registerDistinct = '';
    },
    'form.htBankInfo.registerCity'() {
      // 市变更时，清空区
      this.form.htBankInfo.registerDistinct = '';
    },
    'form.bankType'(newVal, oldVal) {
      // 关键：清除所有字段的校验状态，防止旧规则的报错残留
      // 注意：需要在 $nextTick 中执行，确保 computed 中的 rules 已更新
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate();
      });

      if (newVal === "WSFAS-MC" && this.form.beneficiaryItems.length === 0) {
        this.getSyInfo()
        this.form.wzBankInfo.merchantBizType = '2'
      }
    }
  },
  created() {
    if (this.form.organizationType == '1') {
      this.getSyInfo()
    }
  },
  show(){
    console.log("")
  },
  methods: {
    getSyInfo(){
      this.form.beneficiaryItems = []
      // 提交数据：在此处调用 API
      axios.post('/open-account/getBeneficiaryInfo', {accountId: this.form.accountId})
          .then((res) => {
            if (res.data.code === 200) {
              res.data.data.forEach(item => {
                let certificatesExpiryDate = item.certificatesExpiryDate
                if (certificatesExpiryDate == '9999-12-30') {
                  certificatesExpiryDate = '9999-12-31'
                }
                this.form.beneficiaryItems.push({
                  certificatesType: item.certificatesType,
                  beneficiaryIdEffDate: item.certificatesStartDate,
                  beneficiaryIdOffDate: certificatesExpiryDate,
                  beneficiaryIdNo: item.certificatesNumber,
                  beneficiaryName: item.name,
                  beneficiaryPhone: item.beneficiaryMobile,
                  beneficiaryAddress: item.address,
                  beneficiaryGender: '1',
                  beneficiaryIdType: '1',
                  beneficiaryIdFrontPicIdPath: null,
                  beneficiaryIdFrontPicId: null,
                  beneficiaryIdBackPicIdPath: null,
                  beneficiaryIdBackPicId: null,
                  items: [
                    {
                      beneficiaryType: '100',
                      equityRate: null,
                      equityStartDate: null,
                      equityExpiryDate: null,
                      benefitsRate: null,
                      benefitsStartDate: null,
                      benefitsExpiryDate: null,
                      votingRate: null,
                      votingStartDate: null,
                      votingExpiryDate: null,
                      actualControlType: null,
                      otherRemark: null,
                      mangerPosition: null,
                      otherPosition: null,
                      chnMangerPosition: null,
                      chnOtherPosition: null
                    }
                  ]
                });
              })

            }
          })
          .catch(() => this.$message.error('查询失败'))
    },
    handleTypeChange(row) {
      row.equityRate = null
      row.benefitsRate = null
      row.benefitsStartDate = null
      row.benefitsExpiryDate = null
      row.votingRate = null
      row.votingStartDate = null
      row.votingExpiryDate = null
      row.actualControlType = null
      row.mangerPosition = null
      row.chnMangerPosition = null
    },
    handleControlTypeChange(row) {
      row.items[0].otherRemark = null
    },
    handlePositionChange(row) {
      row.items[0].otherPosition = null
    },
    handleChnPositionChange(row) {
      row.items[0].chnOtherPosition = null
    },
    onSubmit() {
      if (this.htAgreeFlag || this.form.bankType !== 'HT-MC') {
        this.$refs.formRef.validate((valid) => {
          console.log(valid)
          if (!valid) {
            this.$message.error('请完善数据！')
            return
          }

          let form = {...this.form}
          if (form.beneficiaryItems.length === 0) {
            this.$delete(form, 'beneficiaryItems')
          } else {
            form.beneficiaryItems.forEach(item => {
              if (this.form.bankType === 'HT-MC') {
                this.$delete(item, 'beneficiaryIdFrontPicId')
                this.$delete(item, 'beneficiaryIdFrontPicIdPath')
                this.$delete(item, 'beneficiaryIdBackPicId')
                this.$delete(item, 'beneficiaryIdBackPicIdPath')
              } else {
                this.$delete(item, 'items')
              }
            })
          }

          // 提交数据：在此处调用 API
          axios.post('/open-account/createBankAccount', form)
              .then((res) => {
                if (res.data.code === 200) {
                  this.$message.success('开户成功')
                  this.$router.back()
                } else {
                  this.$message.error(res.data.msg)
                }
              })
              .catch(() => this.$message.error('保存失败'))
        });
      } else {
        this.$message.error('未同意华通银行证明无法保存')
      }
    },
    // 校验：URL
    validateURL(value, cb) {
      if (!value) return cb();
      try {
        // 简单 URL 校验
        // eslint-disable-next-line no-new
        new URL(value.indexOf('://') > -1 ? value : `https://${value}`);
        cb();
      } catch (e) {
        cb(new Error('请输入有效的URL，例如 https://example.com'));
      }
    },
    // ===== 动态规则：股东/受益人 =====
    shareholderRemarkReqRules(jg){
      return !jg ? [] : [{ required:true, message:'必填', trigger:'change' },{ max: 500, message: '长度最多500个字符', trigger: 'change' }]
    },
    shareholderTyReqSelRules(jg){
      return jg ? [{ required:true, message: '必选', trigger:'change' }] : []
    },
    shareholderSexReqSelRules(item){
      return (item.certificatesType != '0' && item.certificatesType != '1' && item.certificatesType != '7' && item.certificatesType != '8') ? [{ required:true, message:'必选', trigger:'change' }] : []
    },
    shareholderRateReqSelRules(jg){
      return jg ? [{ required:true, message: '必填', trigger:'change' }, { pattern: /^(\d{0,2}(\.\d{0,2})?)|100$/, message: "只能是数值格式2位整数2位小数，最大值100", trigger: "change" }] : []
    },
    handleClickAgree() {
      this.lookAgreeVisiable = true

      // 使用 fetch 获取文件流
      fetch('/agree.docx')
          .then(response => response.arrayBuffer())
          .then(arrayBuffer => {
            // 使用 mammoth 转换
            return mammoth.convertToHtml({ arrayBuffer: arrayBuffer });
          })
          .then(result => {
            this.htmlContent = result.value; // 转换后的 HTML
            this.form.htBankInfo.entryTime = new Date();
            // result.messages 包含警告信息
          })
          .catch(err => {
            console.error("转换失败", err);
            this.$message.error("协议加载失败");
          });
    },
    handleSelectedAgree(val) {
      if (val && !this.lookAgree) {
        this.$message.error('请先阅读华通银行“e账户”注册会员号管理协议！')
        this.htAgreeFlag = false
      }
      if (val) {
        this.form.htBankInfo.checkboxClickTime = new Date();
      }
    },
    handleCloseLookAgree() {
      let closeDate = new Date();
      // 2. 获取毫秒差
      let diffMs = closeDate.getTime() - this.form.htBankInfo.entryTime.getTime();

      // 3. 转换为秒 (可以使用 Math.abs 取绝对值，确保为正数)
      this.form.htBankInfo.readingDuration = Math.floor(Math.abs(diffMs / 1000));

      this.lookAgree = true
    },
    uploadSuccess(response, file, index) {
      console.log("返回结果")
      console.log(response)
      if (response && response.code === 0) {
        // 假设返回的数据中包含文件路径
        this.form.htBankInfo[index] = response.uuid
        this.form.htBankInfo[index + 'Path'] = response.url;
        this.$message.success('上传成功');
      } else {
        this.form.htBankInfo[index] = '';
        this.form.htBankInfo[index + 'Path'] = '';
        this.$message.error(response.msg || '上传失败');
      }
    },
    uploadError(error, file, index) {
      console.log("上传失败", error, index);
      // 重置文件路径，允许重新上传
      this.form.htBankInfo[index] = null;
      this.form.htBankInfo[index + 'Path'] = null;
      this.$message.error('上传失败，请重试');
    },
    uploadWzSuccess(response, file, index) {
      console.log("返回结果")
      console.log(response)
      let files = this.form.wzBankInfo.fileList
      let fileInfo = files[index]
      if (response && response.code === 0) {
        // 假设返回的数据中包含文件路径
        fileInfo.filePath = response.url
        fileInfo.fileIdentifier = response.uuid
        fileInfo.fileType = response.fileType
        this.$message.success('上传成功');
      } else {
        fileInfo.filePath = '';
        fileInfo.fileIdentifier = '';
        fileInfo.fileType = '';
        this.$message.error(response.msg || '上传失败');
      }
      this.$set(files, index, fileInfo)
    },
    uploadWzError(error, file, index) {
      console.log("上传失败", error, index);
      // 重置文件路径，允许重新上传
      this.form.wzBankInfo.fileList[index].filePath = '';
      this.form.wzBankInfo.fileList[index].fileType = '';
      this.form.wzBankInfo.fileList[index].fileIdentifier = '';
      this.$message.error('上传失败，请重试');
    },
    uploadSfzSuccess(response, file, index, key) {
      console.log("返回结果")
      console.log(response)
      if (response && response.code === 0) {
        // 假设返回的数据中包含文件路径
        this.form.beneficiaryItems[index][key] = response.uuid
        this.form.beneficiaryItems[index][key + 'Path'] = response.url;
        this.$message.success('上传成功');
      } else {
        this.form.beneficiaryItems[index][key] = null;
        this.form.beneficiaryItems[index][key + 'Path'] = null;
        this.$message.error(response.msg || '上传失败');
      }
    },
    uploadSfzError(error, file, index, key) {
      console.log("上传失败", error, index);
      // 重置文件路径，允许重新上传
      this.form.beneficiaryItems[index][key] = null;
      this.form.beneficiaryItems[index][key + 'Path'] = null;
      this.$message.error('上传失败，请重试');
    },
    handleClickUpload(index) {
      let fileInfo = this.form.htBankInfo[index]
      // 如果已有图片，则手动触发上传组件的点击事件
      if (fileInfo) {
        this.form.htBankInfo[index] = null;
        this.form.htBankInfo[index + 'Path'] = null;
      }
    },
    handleClickSfzUpload(index,key) {
      let fileInfo = this.form.beneficiaryItems[index]
      // 如果已有图片，则手动触发上传组件的点击事件
      if (fileInfo[key]) {
        fileInfo[key] = null;
        fileInfo[key + 'Path'] = null;
      }
    },
    handleClickWzUpload(index) {
      let fileInfo = this.form.wzBankInfo.fileList[index]
      // 如果已有图片，则手动触发上传组件的点击事件
      if (fileInfo) {
        fileInfo.filePath = '';
        fileInfo.fileIdentifier = '';
      }
    }
  },
};
</script>

<style scoped>
/deep/ .el-select {
  width: 100%;
}
.open-bank-form {
  background: #fff;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px
}
.agreeContainer{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.word-content {
  overflow-y: auto;
  border: 1px solid #eee;
  padding: 20px;
}
.avatar-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
</style>
